/**
 * Schemes that must never be navigated to: on this page they would run script
 * on the app's own origin (`javascript:`), render attacker content in it
 * (`data:`), or read local resources. Mirrors the API's redirect_uri rules.
 */
const FORBIDDEN_REDIRECT_SCHEMES = new Set([
  'javascript',
  'data',
  'vbscript',
  'file',
  'blob',
  'about',
  'filesystem',
  'view-source',
  'intent',
  'chrome',
  'chrome-extension',
  'moz-extension',
  'resource',
])

/** Single-word app schemes of known MCP clients (see the API allowlist). */
const KNOWN_CLIENT_SCHEMES = new Set([
  'cursor',
  'vscode',
  'vscode-insiders',
  'windsurf',
  'claude',
  'chatgpt',
  'zed',
  'raycast',
])

/**
 * Whether a URL from the API is safe to hand to the browser: web pages
 * (http/https), or an app hand-off on a reverse-DNS or known MCP client
 * scheme. Defense in depth — the API already refuses anything else.
 */
export function isSafeProviderRedirect(url: string): boolean {
  if (typeof url !== 'string' || url.length === 0) return false
  for (let index = 0; index < url.length; index += 1) {
    const code = url.charCodeAt(index)
    if (code <= 0x20 || (code >= 0x7f && code <= 0x9f)) return false
  }
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return false
  }
  const scheme = parsed.protocol.slice(0, -1).toLowerCase()
  if (scheme === 'https' || scheme === 'http') return parsed.hostname !== ''
  if (FORBIDDEN_REDIRECT_SCHEMES.has(scheme)) return false
  if (!/^[a-z][a-z0-9+.-]*$/.test(scheme)) return false
  return scheme.includes('.') || KNOWN_CLIENT_SCHEMES.has(scheme)
}
